(ns frontend.ux-overhaul.listing.sales-opportunity.won-selector
  "The selector of the sale agreement that makes a sales opportunity won, for the
   listing of sales opportunities. The viewer of a sales opportunity renders the
   same selector, with a flag in its own state. The menu of a card needs it
   outside of the viewer."
  (:require
   [common.localization :as loc]
   [frontend.actions.sales-opportunity :as sales-opportunity-actions]
   [frontend.domain.sales-opportunity.actions :as sales-opportunity-domain-actions]
   [frontend.logging :as logging]
   [ui.modals.entity-selector.view :as entity-selector]))

(defn view
  "Select or create the sale agreement, then set the sales opportunity to won.
   `on-close!` is called when the selector closes, with or without a selection."
  [{:keys [sales-opportunity on-close!]}]
  [entity-selector/view
   {:title                  (loc/tr :select-or-create-agreement)
    :entity-types           [:entity.type/sale-agreement]
    :new-entity-start-value (sales-opportunity-domain-actions/agreement-start-value sales-opportunity)
    :label                  (loc/tr :entity.type/sale-agreement)
    :on-select!             (fn [agreement-id]
                              (on-close!)
                              (sales-opportunity-actions/*->won!
                               {:sales-opportunity-id (:db/id sales-opportunity)
                                :sale-agreement-id    agreement-id}
                               (fn [_])
                               (fn [err]
                                 (logging/error "Failed to set sales oppo as Won " err))))
    :on-cancel!             (fn [_]
                              (on-close!))}])
